import React, { useEffect } from "react";

// Компонент модального вікна зображення
const ImageModal = ({ isOpen, src, alt, onClose }) => {
  // Ефект для закриття вікна по натисканню клавіші 'Escape'
  useEffect(() => {
    if (!isOpen) {
      return;
    }
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose, isOpen]);

  // Рендеремо модальне вікно, якщо відкрито
  if (!isOpen) {
    return null;
  }

  return (
    <div className="image-modal" onClick={onClose} role="dialog" aria-modal="true">
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose}>×</button>
        <img src={src} alt={alt} />
      </div>
    </div>
  );
};

export default ImageModal;
